import { render, staticRenderFns } from "./CV-Long.vue?vue&type=template&id=3a811e2a&scoped=true&"
import script from "./CV-Long.vue?vue&type=script&lang=js&"
export * from "./CV-Long.vue?vue&type=script&lang=js&"
import style0 from "./CV-Long.vue?vue&type=style&index=0&id=3a811e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a811e2a",
  null
  
)

export default component.exports